<template>
  <div>
    <EditBillingEntryModal v-model="showEditModal" :entry="editingItem" @saved="OnEntrySaved" />
    <b-button
      v-if="entry.needsReview"
      v-b-tooltip.hover.top="'Confirm as is'"
      class="btn-sml"
      variant="success"
      title="Confirm as is"
      @click="ConfirmAndSave"
    ><i class="fa fa-check"></i></b-button>
    <b-button
      v-else-if="!entry.needsReview && entry.chargeLabel == 'Manual Charge'"
      v-b-tooltip.hover.top="'Revert to Needs Review'"
      class="btn-sml"
      variant="danger"
      title="Revert to Needs Review"
      @click="RevertToReview"
    ><i class="fa fa-times"></i></b-button>
    <b-button
      v-if="entry.chargeType == 'ConnectAdministrative' || entry.chargeType == 'ConnectFulfillmentCharge'"
      v-b-tooltip.hover.left="'Delete Charge'"
      class="btn-sml"
      variant="danger"
      title="Delete Charge"
      @click="DeleteCharge"
    ><i class="fa fa-trash"></i></b-button>
    <b-button
      :disabled="!canEdit"
      v-b-tooltip.hover.left="canEdit ? 'Edit Charge' : 'Imported from WMS - Cannot Edit'"
      class="btn-sml"
      variant="primary"
      @click="StartEdit"
    ><i class="fa fa-pencil"></i></b-button>
    <b-button
      v-if="entry.needsReview || (isDeveloper && entry.chargeType == 'ConnectFreightCharge')"
      v-b-tooltip.hover.left="'Reprocess'"
      class="btn-sml"
      variant="warning"
      title="Reprocess"
      @click="Reprocess"
    ><i class="fa fa-area-chart"></i></b-button>
    <b-button
      v-if="entry.rateCardId && entry.comment"
      v-b-tooltip.hover.left="entry.comment"
      class="btn-sml"
      variant="info"
      :title="entry.comment"
      :to="{ name: 'Billing.RateCards.View', params: { id: entry.rateCardId }, query: { rateCardItemId: entry.rateCardItemId } }"
    ><i class="fa fa-info"></i></b-button>
    <b-button
      v-else-if="entry.comment"
      v-b-tooltip.hover.left="entry.comment"
      class="btn-sml"
      variant="info"
      :title="entry.comment"
    ><i class="fa fa-info"></i></b-button>
    <b-button
      v-if="entry.brandInvoiceId"
      v-b-popover.hover="'Was Invoiced, click to open!'"
      class="btn-sml"
      variant="primary"
      :to="{ name: 'Billing.CustomerInvoices.View', params: { id: entry.brandInvoiceId } }"
      title="Open Invoice"
    ><i class="fa fa-eye"></i></b-button>
    <b-button
      v-else
      v-b-tooltip.hover.left="'Not invoiced yet'"
      class="btn-sml"
      variant="secondary"
      title="Not invoiced yet"
    ><i class="fa fa-eye"></i></b-button>
  </div>
</template>

<script>
import EditBillingEntryModal from './partials/billing/EditBillingEntryModal.vue';

export default {
  name: 'BillingEntryActions',
  components: { EditBillingEntryModal },
  props: {
    entry: {
      type: Object,
      required: true
    },
    isDeveloper: {
      type: Boolean,
      default: false
    }
  },
  data: function() {
    return {
      showEditModal: false,
      editingItem: null
    };
  },
  computed: {
    canEdit: function() {
      var externalSyncedTypes = [
        'TPLHandling', 'TPLAutoCalcStorage', 'TPLMaterials',
        'TPLPrepaidFreight', 'TPLThirdPartyFreight', 'TPLStorage',
        'TPLSpecialCharges', 'TPLAutoCalcHandling'
      ];
      return externalSyncedTypes.indexOf(this.entry.chargeType) === -1;
    }
  },
  methods: {
    ConfirmAndSave: function() {
      this.$http.post('/api/common/brandInvoices/confirmAndSaveItem', {
        orderChargeItemId: this.entry.id,
        singleUnitCharge: this.entry.singleUnitCharge
      })
        .then(function() { this.$emit('changed'); }.bind(this))
        .catch(function() {});
    },
    RevertToReview: function() {
      this.$http.post('/api/common/brandInvoices/revertAndSaveItem', {
        orderChargeItemId: this.entry.id,
        singleUnitCharge: 0
      })
        .then(function() { this.$emit('changed'); }.bind(this))
        .catch(function() {});
    },
    DeleteCharge: function() {
      this.$swal({
        title: 'Delete this charge?',
        text: 'This action cannot be undone.',
        icon: 'warning',
        buttons: ['Cancel', 'Delete'],
        dangerMode: true
      }).then(function(confirmed) {
        if (!confirmed) return;
        this.$http.post('/api/common/brandInvoices/deleteItem', {
          orderChargeItemId: this.entry.id
        })
          .then(function() { this.$emit('changed'); }.bind(this))
          .catch(function() {});
      }.bind(this));
    },
    StartEdit: function() {
      this.editingItem = this.entry;
      this.showEditModal = true;
    },
    OnEntrySaved: function(updatedEntry) {
      this.$emit('changed', updatedEntry);
    },
    Reprocess: function() {
      if (!this.entry.brandInvoiceId) {
        this.$swal('Must be part of an invoice to be reprocessed!');
        return;
      }
      this.$http.post('/api/common/brandInvoices/resprocessItem/' + this.entry.brandInvoiceId + '/' + this.entry.id)
        .then(function() {
          this.$swal('Item queued up to be reprocessed!');
        }.bind(this))
        .catch(function() {});
    }
  }
};
</script>
